import React, { useState, useEffect, useRef } from "react";
// import "./CustomDropdown.css";

const RegistrationDropdown = ({
  options,
  selectedOption,
  onChange,
  id,
  label,
  searchable,
  disabled
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    if (!disabled) {
    setIsOpen((prevState) => !prevState);
    setSearchTerm(""); // Clear search when dropdown is toggled
    setFilteredOptions(options); // Reset options when dropdown is toggled
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value; // Keep the original input as-is
  setSearchTerm(term); // Store the user input for display in the search box

  setFilteredOptions(
    options.filter((option) =>
      option.name.toLowerCase().includes(term.toLowerCase()) // Perform a case-insensitive search
    )
    );
  };

  const handleSelectOption = (option) => {
    onChange({
      target: {
        id: id, // Pass the id of the dropdown to match the current handleInputChange
        value: option ? option.name : "",
      },
    });
    setIsOpen(false); // Close dropdown after selection
  };

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-container" onClick={toggleDropdown}>
        <div className="selected-option">
          {selectedOption ? selectedOption.name : "Select an option"}
        </div>
        <div className={`arrow ${isOpen ? "open" : ""}`}>&#x25BC;</div>
      </div>

      {isOpen && (
        <div className="options-list">
          {searchable && (
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
            />
          )}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className="option"
                onClick={() => handleSelectOption(option)}
              >
                {option.name}
              </div>
            ))
          ) : (
            <div className="no-options">No options found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default RegistrationDropdown;
